import { UpgradeFunction, versionToUpgradeFunctions } from './schemaUpgradeRepo.util'
import Logger from '../../services/logger.service'

export const performUpgrade = (jsonPcr: any, version: string) => {
  const functionArray: UpgradeFunction[] | undefined = versionToUpgradeFunctions.get(version)
  if (functionArray) {
    Logger.log(`Running upgrade scripts for version: ${version}`)

    for (const f of functionArray) {
      jsonPcr = f(jsonPcr)
    }
  }
  jsonPcr.version = version
}
